import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Drawer,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import ForLawyersLogo from "./assets/forLawyersLogo.png";
import "./signupToolbar.css";

function SignupToolbar({ onlyHelp = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    // Prevent 'Tab' and 'Shift' from closing the drawer
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  // NavItems renders different buttons depending on the onlyHelp prop
  const NavItems = () => {
    if (onlyHelp) {
      return (
        <a href="/help" className="nav-link outlined">
          Need help?
        </a>
      );
    }
    return (
      <>
        <a href="/" className="nav-link">
          Find a lawyer
        </a>
        <div className="vertical-rule" />
        <a href="/grow/email" className="nav-link">
          Sign In
        </a>
        <a href="/help" className="nav-link outlined">
          Need help?
        </a>
      </>
    );
  };

  // Drawer content for mobile devices
  const drawerContent = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px",
        width: "200px",
      }}
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <NavItems />
    </div>
  );

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      style={{ backgroundColor: "white", top: 0, zIndex: 1200 }}
    >
      <Toolbar className="header" sx={{ justifyContent: "space-between" }}>
        {/* Left section: Logo */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <a href="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              src={ForLawyersLogo}
              alt="QuidPro for Lawyers Logo"
              style={{ height: 40, marginRight: 8 }}
            />
          </a>
        </div>

        {/* Right section: Nav items or mobile Drawer */}
        {isMobile ? (
          <>
            <IconButton
              edge="end"
              color="inherit"
              onClick={toggleDrawer(true)}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
            >
              {drawerContent}
            </Drawer>
          </>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <NavItems />
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default SignupToolbar;
